import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import {
  Box,
  Button,
  Container,
  Link,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import imgSrc from '../Image/error-401.png';
import MainLayout from '../layoutV2/MainLayout';
import { usePageTitleStore } from '../store/PageTitleStore';

function ForbiddenErrorPage() {
  const { updateTitle } = usePageTitleStore();

  useEffect(() => {
    updateTitle('403 error forbidden');
  }, []);

  return (
    <MainLayout>
      <Box
        component='main'
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          minHeight: '100%',
        }}
      >
        <Container maxWidth='md'>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                mb: 3,
                textAlign: 'center',
              }}
            >
              <img
                alt='Under development'
                src={imgSrc}
                style={{
                  display: 'inline-block',
                  maxWidth: '100%',
                  width: 400,
                }}
              />
            </Box>
            <Typography
              align='center'
              sx={{ mb: 3 }}
              variant='h3'
              fontWeight={700}
            >
              403: Forbidden
            </Typography>
            <Typography align='center' color='text.secondary' variant='body1'>
              You are not authorized to access the resource you requested for.
              You may enquire further at{' '}
              <Link
                color={'primary.main'}
                href={`mailto:connect@vaysolar.com`}
                underline='none'
              >
                connect@vaysolar.com
              </Link>
              .
            </Typography>
            <Stack direction='row' spacing={3} sx={{ my: 3 }}>
              <Button
                href='/'
                startIcon={
                  <SvgIcon fontSize='small'>
                    <ArrowLeftIcon />
                  </SvgIcon>
                }
                disableElevation
                variant='contained'
              >
                Home
              </Button>
              <Button
                href='/'
                endIcon={
                  <SvgIcon fontSize='small'>
                    <QuizOutlinedIcon />
                  </SvgIcon>
                }
                variant='outlined'
              >
                Help
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>
    </MainLayout>
  );
}

export default ForbiddenErrorPage;
